export default __webpack_public_path__ + "static/media/video-thumb.05f1866d.svg";